//@flow
import { HiverAxios, showMessage, sendTrackingEvent } from 'h-commons';
import {
  REMOVE_USER_INIT,
  REMOVE_USER_FAILED,
  REMOVE_USER_DONE
} from './types';

export function removeUsers(ids: Array<string | number>, done: Function) {
  return (dispatch: Function) => {
    dispatch({
      type: REMOVE_USER_INIT
    });
    HiverAxios({
      url: '/api/settings/users/changestate/block',
      type: "POST",
      params: {
        userIds: ids
      },
      callback: (response) => {
        if (response.data) {
          dispatch({
            type: REMOVE_USER_DONE,
            payload: ids
          });
          showMessage({
            message: `Removed ${ids.length} user${ids.length > 1 ? 's' : ''}`,
            type: 'success'
          })
          sendTrackingEvent('removedUGUser');
          done({ deletedUserIds: ids });
        } else {
          dispatch({
            type: REMOVE_USER_FAILED
          });
          showMessage({
            message: `User deletion failed. Something broke. 😞  Try again. If it still does not work, get in touch with Hiver customer support.`,
            type: 'error'
          });
        }
      },
      onfail: () => {
        dispatch({
          type: REMOVE_USER_FAILED
        });
        showMessage({
          message: `User deletion failed. Something broke. 😞  Try again. If it still does not work, get in touch with Hiver customer support.`,
          type: 'error'
        });
      }
    });
  };
}
